// import React from 'react';

// This patch replaces findDOMNode with a ref-based approach
export default function applyTransitionGroupFix() {
  // Only patch once
  if (window.transitionGroupPatched) return;
  
  try {
    // Get the react-dom module
    const ReactDOM = require('react-dom');
    
    // Create a replacement for findDOMNode that works in React 18
    if (!ReactDOM.findDOMNode || typeof ReactDOM.findDOMNode !== 'function') {
      ReactDOM.findDOMNode = function(componentOrElement) {
        if (componentOrElement == null) {
          return null;
        }
        if (componentOrElement.nodeType) {
          return componentOrElement;
        }
        // For components, we try to use the associated DOM node
        return componentOrElement.base || componentOrElement.node || 
               (componentOrElement._reactInternals && 
                componentOrElement._reactInternals.stateNode) || null;
      };
    }
    
    window.transitionGroupPatched = true;
    console.log('React Transition Group patch applied successfully');
  } catch (e) {
    console.error('Failed to apply Transition Group fix:', e);
  }
}